import React from 'react';
import { Tab } from '@mui/material';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';

import { TabsWrapper, WhiteContainer } from 'src/style/common';
import AppkeyAutocomplete from 'src/components/AppkeyAutocomplete';
import CustomBilling from 'src/pages/BillingAndPlan/components/CustomBilling';
import { PaymentHistory } from 'src/pages/BillingAndPlan/components/PaymentHistory';

const CustomPricing: React.FC = () => {
  const [selectedAppkey, setSelectedAppkey] = React.useState<{
    label: string;
    key: string;
  } | null>(null);

  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (_event: unknown, newValue: number) => {
    setActiveTab(newValue);
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  return (
    <DashboardPageLayout title="Billing & Plan">
      <>
        <AppkeyAutocomplete selectedAppkey={selectedAppkey} setSelectedAppkey={setSelectedAppkey} />
        {selectedAppkey && (
          <>
            <TabsWrapper value={activeTab} indicatorColor="primary" onChange={handleTabChange} style={{ marginTop: 24 }}>
              <Tab label="Billing & Plans" {...a11yProps(0)} data-testid="billing-tab" style={{ minWidth: 130 }} />
              <Tab label="Payment History" {...a11yProps(1)} data-testid="payment-history-tab" style={{ minWidth: 145 }} />
            </TabsWrapper>
            <WhiteContainer style={{ padding: activeTab === 1 ? 0 : 24 }}>
              {activeTab === 0 && <CustomBilling selectedAppKey={selectedAppkey.key} />}
              {activeTab === 1 && <PaymentHistory appKey={selectedAppkey.key} />}
            </WhiteContainer>
          </>
        )}
      </>
    </DashboardPageLayout>
  );
};

export default CustomPricing;
